import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import common from './modules/common'
import user from './modules/user'
import dataDictionary from './modules/dataDictionary';
import attFilesDictionary from './modules/attFilesDictionary';
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    user,
    dataDictionary,
    attFilesDictionary
  },
  mutations: {
    // 重置vuex本地储存状态
    resetStore (state) {
      Object.keys(state).forEach((key) => {
        state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
      })
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
